// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c078dc57","722":"5098d7bf","894":"a866d5f4"}[chunkId] + ".chunk.js";
};